import type { CalendarPaymentItem } from '#app/hooks/queries/usePaymentsAllQuery/types';
import { getActiveCatalogHubId } from '#app/utils/repoObligationEntries';

/** catalog_hub_id выплаты из matched payout, raw или item. */
export function getPaymentCatalogHubId(payment: CalendarPaymentItem): number | null {
  const matched = payment.matchedPayout;
  if (matched?.catalog_hub_id != null) {
    const hub = Number(matched.catalog_hub_id);
    if (Number.isFinite(hub)) return hub;
  }

  const raw = payment.raw as Record<string, unknown> | undefined;
  const fromRaw = raw?.catalog_hub_id ?? raw?.ticker_hub_id;
  if (fromRaw != null && fromRaw !== '') {
    const hub = Number(fromRaw);
    if (Number.isFinite(hub)) return hub;
  }

  if (payment.catalog_hub_id != null) {
    const hub = Number(payment.catalog_hub_id);
    if (Number.isFinite(hub)) return hub;
  }

  const item = payment.item;
  if (item) {
    const hub = getActiveCatalogHubId(item as Parameters<typeof getActiveCatalogHubId>[0]);
    if (hub != null) return hub;
  }

  return null;
}
